import React from 'react';

export const PageHeader = (props: any) => {
    return (
        <>
            <div className="border-bottom mb-4 py-6" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">{props.children}</div>
            </div>
        </>
    );
};
